/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import Spinner from 'sushiweb/Spinner/Spinner';
import { green, grey } from 'sushiweb/tokens/color';
import { AddEdit, ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { ChevronLeft, ChevronRight } from 'sushiweb/Icons';
import { toNumber } from 'lodash-es';

const headCss = 'tw-text-400 tw-font-semibold tw-text-left ';
const listCss = 'tw-text-300 tw-font-regular tw-text-left ';

const ContentHead = () => {
  return (
    <div className='tw-w-full tw-flex tw-justify-between tw-gap-10 '>
        <span className={`tw-w-[30%] ${headCss}`}>Text</span>
        <span className={`tw-w-[15%] ${headCss}`}>Roles</span>
        <span className={`${headCss} tw-w-[15%]`}>Start Timestamp</span>
        <span className={`${headCss} tw-w-[15%]`}>End Timestamp</span>
        <span className={`${headCss} tw-w-[11%]`}>Organization</span>
        <span className={`${headCss} tw-w-[11%]`}>Active Status</span>
        <span className={`${headCss} tw-w-[3%]`}></span>
    </div>
  );
};

// Announcement Row component
const AnnouncementRow = ({
  key,
  textToShow,
  item,
  idPermissionMap,
  idOrganisationMap,
  getReadableTimeStamp,
  setUpdateStateDetails,
  setUpdateAnnouncementDetails,
}) => {
  // state to show all roles or a limited view
  const [showAllRoles, setShowAllRoles] = useState(false);

  const roleIds = Array.isArray(item?.role_ids) ? item.role_ids : [];
  const visibleRoles = showAllRoles ? roleIds : roleIds.slice(0, 3);

  return (
    <div
      className='tw-w-full tw-flex tw-justify-between tw-rounded-xl tw-border-solid tw-border-grey-200 tw-p-4 tw-items-center tw-gap-10 tw-pr-0 hover:tw-border-grey-300 hover:tw-bg-grey-200'
      key={key}
    >
        <span className={`tw-w-[30%] ${listCss}`}>
          {textToShow.length <= 40
            ? textToShow
            : textToShow.substring(0, 50) + '...'}
        </span>

        {/* roles */}
        <span className={`tw-w-[15%] ${listCss} tw-flex tw-gap-1 tw-flex-wrap`}>
          {visibleRoles?.map((roleId) => {
            return (
              <span
                key={`role_id_${roleId}`}
                className='tw-text-[1rem] tw-bg-green-700 tw-text-white tw-px-4 tw-py-2 tw-rounded-2xl tw-max-h-10'
              >
                {idPermissionMap[roleId]}
              </span>
            );
          })}

          {/* See more/less button */}
          {item.role_ids.length > 3 && (
            <div
              onClick={() => setShowAllRoles(!showAllRoles)}
              className='tw-border-none tw-ml-1 tw-rounded-[6px] tw-flex tw-items-center tw-gap-1 tw-text-green-700 tw-cursor-pointer tw-bg-transparent'
            >
              {showAllRoles ? 'See Less' : 'See More'}
              <span>
                {!showAllRoles ? (
                  <ChevronDown size={16} color={green.z700} />
                ) : (
                  <ChevronUp size={16} color={green.z700} />
                )}
              </span>
            </div>
          )}
        </span>

        {/* start timestamp */}
        <span className={`${listCss} tw-w-[15%]`}>
          {getReadableTimeStamp(item.start_ts)}
        </span>

        {/* end timestamp */}
        <span className={`${listCss} tw-w-[15%] `}>
          {getReadableTimeStamp(item.end_ts)}
        </span>

        {/* Organization */}
        <span
          key={`role_id_${item?.org_id}`}
          className='tw-text-[1rem] tw-text-300 tw-font-regular tw-text-left tw-w-[11%] tw-px-4 tw-py-2 tw-max-h-10'
        >
          {idOrganisationMap[item?.org_id]}
        </span>

        {/* Status */}
        <span
          className={`${listCss}  tw-w-[11%] tw-flex  tw-items-center tw-justify-center`}
        >
          <label className='switch tw-flex tw-gap-1 '>
            <input
              key={key}
              type='checkbox'
              onChange={(e) => {
                e.preventDefault();
                setUpdateStateDetails({
                  id: item.id,
                  value: e.target.checked,
                });
              }}
              checked={item.is_enabled}
            />
            <span className='slider round'></span>
          </label>
        </span>


        {/* Edit announcement button */}
        <span
          className={`${listCss} tw-w-[3%] tw-flex tw-items-center tw-justify-center tw-cursor-pointer`}
          onClick={() => {
            setUpdateAnnouncementDetails(item);
          }}
        >
          <AddEdit size={16} color={green.z700} />
        </span>
    </div>
  );
};

const AnnouncementList = (props) => {
  const {
    offset,
    previousAnnouncements,
    isAnnouncementsLoading,
    idPermissionMap = {},
    idOrganisationMap = {},
    setOffset = () => {},
    setUpdateStateDetails = () => {},
    setUpdateAnnouncementDetails = () => {},
  } = props;
  const [isNoMoreData, setIsNoMoreData] = useState();

  useEffect(() => {
    if (!previousAnnouncements?.announcements?.length) setIsNoMoreData(true);
    else setIsNoMoreData(false);
  }, [isAnnouncementsLoading, previousAnnouncements]);

  const handlePrev = () => {
    if (offset - 5 >= 0) setOffset((prevState) => prevState - 5);
  };

  const handleNext = () => {
    const announcementsLen = previousAnnouncements?.announcements?.length;
    if (offset + (announcementsLen % 5 === 0))
      setOffset((prevState) => prevState + 5);
  };

  const getReadableTimeStamp = (ts) => {
    var dateUTC = new Date(ts);
    dateUTC = dateUTC.getTime();
    var dateIST = new Date(dateUTC).toLocaleString('en-US', {
      timeZone: 'Asia/Kolkata',
    });
    // Split the date string into its components
    const [month, day, year, hour, min, sec, meridiem] = dateIST.split(/\W+/);

    // Rearrange the components to have the date first
    const rearrangedDateIST = `${day}-${month}-${year}, ${hour}:${min} ${meridiem}`;
    return rearrangedDateIST;
  };

  if (isAnnouncementsLoading)
    return (
      <div className='tw-w-full tw-flex tw-justify-center tw-items-center'>
        <Spinner color={green.z700} />
      </div>
    );
  if (!previousAnnouncements) return null;

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
      {!previousAnnouncements?.announcements?.length ? (
        <div className='tw-w-full tw-flex tw-items-center tw-justify-center tw-text-600 tw-font-medium tw-text-red-500'>
          No data available
        </div>
      ) : null}
      {previousAnnouncements?.announcements?.map((item, index) => {
        const textToShow = item.announcement_text.replace(/<[^>]+>/g, '');
        if (!textToShow?.length) return <></>;
        return (
          <AnnouncementRow
            key={`${item.id}_${index}`}
            textToShow={textToShow}
            item={item}
            idPermissionMap={idPermissionMap}
            idOrganisationMap={idOrganisationMap}
            getReadableTimeStamp={getReadableTimeStamp}
            setUpdateStateDetails={setUpdateStateDetails}
            setUpdateAnnouncementDetails={setUpdateAnnouncementDetails}
          />
        );
      })}

      {/* Pagination */}
      <div className='tw-w-full tw-flex tw-items-center tw-justify-end tw-gap-4'>
        <div className='tw-flex tw-gap-4 '>
          {!isNoMoreData ? (
            <span className='tw-flex tw-justify-center tw-items-center tw-text-400 tw-text-green-700 tw-font-medium'>
              {offset + 1} to{' '}
              {offset + previousAnnouncements.announcements.length}
            </span>
          ) : null}
          <ChevronLeft
            size={25}
            color={`${offset - 5 < 0 ? grey.z300 : green.z700}`}
            onClick={handlePrev}
            className={`${
              toNumber(offset - 5) < 0
                ? 'tw-cursor-none tw-text-grey-500'
                : 'tw-cursor-pointer'
            }`}
          />
          <ChevronRight
            size={25}
            color={`${
              isNoMoreData ||
              offset + (previousAnnouncements.announcements.length % 5) != 0
                ? grey.z300
                : green.z700
            }`}
            onClick={handleNext}
            className='tw-cursor-pointer'
          />
        </div>
      </div>
    </div>
  );
};

const PreviousAnnouncements = (props) => {
  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-4'>
      <div className='tw-font-semibold tw-text-800 tw-text-base-green tw-gap-2'>
        <span>Previous Announcements</span>
      </div>
      <div className='tw-w-full tw-bg-base-white tw-rounded-2xl tw-p-8 tw-flex tw-flex-col tw-gap-8'>
        <ContentHead />
        <hr width='2' size='1' color='#E8E8E8' className='tw-mt-0' />
        <AnnouncementList {...props} />
      </div>
    </div>
  );
};

export default PreviousAnnouncements;
